/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {IPostBOInput} from './../modules/szf-business-op-form/szf-business-op-form.view';
import axios from 'axios';
/**
 * PostBusinessOpCase Input Action
 */
export interface IFile{
    fileData: File | undefined;
    base64: string | ArrayBuffer | null | undefined;
}
export interface IBOCaseAPIPayLoad {
    szf_name: string;
    szf_organizationname: string;
    szf_email: string;
    szf_phoneno: string;
    szf_participatedwithszfpreviously: boolean;
    szf_typeofparticipation: string | null;
    szf_heardaboutus: string | null;
    szf_heardaboutusother: string | null;
    szf_categories: number;
    szf_countrypavilion: string | null;
    szf_productsshowcase: string | null;
    szf_type: string | null;
    szf_source: number;
    szf_kioskactivity: string | null;
    szf_serviceactivity: string | null;
    szf_description: string;
    szf_businessopportunity_Annotations?: {
        filename: string;
        isdocument: boolean;
        subject: string;
        documentbody: string;
    }[];
    "szf_Customer_contact@odata.bind": string;
}
export class PostBusinessOpCaseInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public szf_name: string;
    public szf_organizationname: string;
    public szf_email: string;
    public szf_phoneno: string;
    public szf_participatedwithszfpreviously: boolean;
    public szf_typeofparticipation: string;
    public szf_heardaboutus: string;
    public szf_heardaboutusother: string;
    public szf_categories: number;
    public szf_countrypavilion: string;
    public szf_productsshowcase: string;
    public szf_type: string;
    public szf_kioskactivity: string;
    public szf_serviceactivity: string;
    public szf_description: string;
    public tradeLicenseFile: IFile;
    public presentationFile: IFile;
    public CRMtoken: string | undefined;
    public contactID: string | undefined;
    // public termNcondition: boolean;
    // public updateNpromotion: boolean;
    constructor(data:IPostBOInput) {
        this.szf_name = data.fullName;
        this.szf_organizationname= data.organizationName;
        this.szf_email= data.email;
        this.szf_phoneno= `${data.countryCode}${data.phone}`;
        this.szf_participatedwithszfpreviously= data.previousParticipant ==='1' ? true: false;
        this.szf_typeofparticipation= data.previousParticipantType;
        this.szf_heardaboutus= data.hearAbout;
        this.szf_heardaboutusother= data.others;
        this.szf_categories= data.categories;
        this.szf_countrypavilion= data.listOfCountryPavilions.toString();
        this.szf_productsshowcase= data.typeOfProducts.toString();
        this.szf_type= data.typeOfRestaurantsCoffeeShops ? data.typeOfRestaurantsCoffeeShops : data.typeOfKiosksFoodTrucks;
        this.szf_kioskactivity= data.kioskActivity;
        this.szf_serviceactivity= data.serviceActivity;
        this.szf_description= data.description;
        this.CRMtoken= data.CRMtoken;
        this.contactID= data.contactID;
        this.tradeLicenseFile = {
            fileData: data.tradeLicenseFile,
            base64: data.tradeLicensefileBase64Code
        };
        this.presentationFile = {
            fileData: data.presentationFile,
            base64: data.presentationfileBase64Code
        };
        // this.termNcondition= data.termNcondition;
        // this.updateNpromotion= data.updateNpromotion;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZFBUSINESSOPPCASE`;
    public getCacheObjectType = () => 'SZFBUSINESSOPPCASE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostBusinessOpCaseData {
    status: boolean;
    msg:string | undefined;
    id: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createBOCaseInput = (args: Msdyn365.ICreateActionContext,inputData:IPostBOInput): Msdyn365.IActionInput => {
    return new PostBusinessOpCaseInput(inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function BOCaseDataAction(input: PostBusinessOpCaseInput, ctx: Msdyn365.IActionContext): Promise<IPostBusinessOpCaseData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
    let data: IBOCaseAPIPayLoad = {
        "szf_name": input.szf_name,
        "szf_organizationname": input.szf_organizationname,
        "szf_email": input.szf_email,
        "szf_phoneno": input.szf_phoneno,
        "szf_participatedwithszfpreviously": input.szf_participatedwithszfpreviously,
        "szf_typeofparticipation": input.szf_typeofparticipation ? input.szf_typeofparticipation : null,
        "szf_heardaboutus": input.szf_heardaboutus ? input.szf_heardaboutus : null,
        "szf_heardaboutusother": input.szf_heardaboutusother ? input.szf_heardaboutusother : null,
        "szf_categories": input.szf_categories,
        "szf_countrypavilion": input.szf_countrypavilion ? input.szf_countrypavilion : null,
        "szf_productsshowcase": input.szf_productsshowcase ? input.szf_productsshowcase : null,
        "szf_type": input.szf_type ? input.szf_type : null,
        "szf_source": 1,
        "szf_kioskactivity": input.szf_kioskactivity ? input.szf_kioskactivity : null,
        "szf_serviceactivity": input.szf_serviceactivity ? input.szf_serviceactivity : null,
        "szf_description": input.szf_description,
        "szf_Customer_contact@odata.bind": `/contacts(${input.contactID})` //test contact
    };
    if(input.tradeLicenseFile && input.tradeLicenseFile.fileData && input.tradeLicenseFile.fileData?.name){
        if(data.szf_businessopportunity_Annotations){
            data = {
                ...data,
                "szf_businessopportunity_Annotations": [
                    ...data.szf_businessopportunity_Annotations,
                    {
                        "filename" :`${input.tradeLicenseFile.fileData?.name}`,
                        "isdocument" : true,
                        "subject":`Trade License`,
                        "documentbody" : `${input.tradeLicenseFile.base64}`
                    }
                ]
            }
        }else{
            data = {
                ...data,
                "szf_businessopportunity_Annotations": [
                    {
                        "filename" :`${input.tradeLicenseFile.fileData?.name}`,
                        "isdocument" : true,
                        "subject":`Trade License`,
                        "documentbody" : `${input.tradeLicenseFile.base64}`
                    }
                ]
            }
        }
    }
    if(input.presentationFile && input.presentationFile.fileData && input.presentationFile.fileData?.name){
        if(data.szf_businessopportunity_Annotations){
            data = {
                ...data,
                "szf_businessopportunity_Annotations": [
                    ...data.szf_businessopportunity_Annotations,
                    {
                        "filename" :`${input.presentationFile.fileData?.name}`,
                        "isdocument" : true,
                        "subject":`Presentation`,
                        "documentbody" : `${input.presentationFile.base64}`
                    }
                ]
            }
        }else{
            data = {
                ...data,
                "szf_businessopportunity_Annotations": [
                    {
                        "filename" :`${input.presentationFile.fileData?.name}`,
                        "isdocument" : true,
                        "subject":`Presentation`,
                        "documentbody" : `${input.presentationFile.base64}`
                    }
                ]
            }
        }
    }
    const response = await axios.post(`${szfCRMDomain}/api/data/v9.2//szf_businessopportunities`,data,{
        headers: { 
            'Prefer': 'return=representation', 
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${input.CRMtoken}`,
            'Cookie': 'ARRAffinity=a0cabaca1e89d18f0f4123d056dbb9e1cefb17d8da01b66962b2dc7ffb4a189deb29bb4b19df1459d2ea781b605f33064b9fea1f144b525b9d7676625c4ffb5408DB5EAB3C80FFDC613303632; ReqClientId=797635cc-3220-4d23-95ab-4c1fd0f38f88; orgId=df0699dc-bf43-4643-8928-2934590e2913'
        },
        timeout: 25000
    })

    // const response = await Msdyn365.sendRequest<any>(`https://operations-szf-uat.crm15.dynamics.com/api/data/v9.2//szf_businessopportunities`, "post", data, {
    //     headers: {
    //         'Prefer': 'return=representation',
    //         'Content-Type': 'application/json',
    //         'content-length': '999999999999',
    //         'Authorization': `Bearer ${input.CRMtoken}`,
    //         'Cookie': 'ARRAffinity=a0cabaca1e89d18f0f4123d056dbb9e1cefb17d8da01b66962b2dc7ffb4a189deb29bb4b19df1459d2ea781b605f33064b9fea1f144b525b9d7676625c4ffb5408DB5EAB3C80FFDC613303632; ReqClientId=797635cc-3220-4d23-95ab-4c1fd0f38f88; orgId=df0699dc-bf43-4643-8928-2934590e2913'
    //     }
    // });
    if(response && response.data && response.data.szf_businessopportunityid){
        return {
            status: true,
            msg: 'success',
            id: response.data.szf_businessopportunityid
        };
    }else if (response && response.data && response.data.error){
        return {
            status: false,
            msg: response.data.error.message,
            id: undefined
        };
    }else{
        return {
            status: false,
            msg: undefined,
            id: undefined
        };
    }
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPostBusinessOpCaseData[]>('/get/example/id/1', 'get');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostBusinessOpCaseData>>BOCaseDataAction,
    // TODO: Give your data action a unique id
    id: 'PostBusinessOpCase',
    input: createBOCaseInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
